export default "__VITE_ASSET__BnJW8WCJ__"